import { render, staticRenderFns } from "./Wiki.vue?vue&type=template&id=58280aea&"
import script from "./Wiki.vue?vue&type=script&lang=js&"
export * from "./Wiki.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58280aea')) {
      api.createRecord('58280aea', component.options)
    } else {
      api.reload('58280aea', component.options)
    }
    module.hot.accept("./Wiki.vue?vue&type=template&id=58280aea&", function () {
      api.rerender('58280aea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Wiki.vue"
export default component.exports